// extracted by mini-css-extract-plugin
export default {"spinWrapper":"LoadModal_spinWrapper__NSdDC","loadingIconContainer":"LoadModal_loadingIconContainer__lSHxm"};